import React from 'react';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import StrategyPage from '../components/legendary/StrategyPage';

export default function LegendaryWeinstein() {
  return (
    <StrategyPage
      strategyKey="WEINSTEIN"
      title="Weinstein Stage 2"
      icon={<ShowChartIcon />}
      color="#10b981"
    />
  );
}
